import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalCheckTotal.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalCheckTotal.error;
export const mentalCheckTotalResponse = (state: RootState) =>
  state.mentalCheckTotal.mentalCheckTotalResponse;
